const CMTPAX_UPDATED = (state, Cmtpax) => {
  state.Cmtpax = Cmtpax
}

export default {
  CMTPAX_UPDATED
}
